
import { g, layers } from '@hcie/core';
import { EventBus } from '@hcie/shared';
import { SelectionTransformUI } from './selection-transform-ui';

/**
 * @file raster-transform-action.ts
 * @description Undo/Redo action for raster transform operations and floating content state management
 */

export class RasterTransformAction {
    constructor(
        public description: string,
        public layerIndex: number,
        public beforeImageData: ImageData,
        public afterImageData: ImageData,
        public beforeShapes?: any[],
        public afterShapes?: any[]
    ) {}

    undo() {
        const layer = layers[this.layerIndex];
        if (layer) {
            (layer.ctx as CanvasRenderingContext2D).putImageData(this.beforeImageData, 0, 0);
            if (this.beforeShapes) layer.shapes = [...this.beforeShapes];
            EventBus.emit('RENDER_LAYERS');
        }
    }

    redo() {
        const layer = layers[this.layerIndex];
        if (layer) {
            (layer.ctx as CanvasRenderingContext2D).putImageData(this.afterImageData, 0, 0);
            if (this.afterShapes) layer.shapes = [...this.afterShapes];
            EventBus.emit('RENDER_LAYERS');
        }
    }
}

/**
 * Single Source of Truth for floating content: use @hcie/core's global state 'g'
 * but also sync with window for robustness across module boundaries.
 */
export const getFC = () => g.floatingContent || (window as any).floatingContent || null;

export function setFloatingContent(content: any): void {
    g.floatingContent = content;
    (window as any).floatingContent = content;
}

// Update handles on zoom to prevent drift
EventBus.on('ZOOM_CHANGED', () => {
    const transformer = (window as any).transformUI as SelectionTransformUI;
    if (transformer && transformer.active) {
        transformer.updatePosition();
    }
});